import './style.css';

import { StylesProvider, Tooltip, withStyles } from '@material-ui/core';

import { Place } from '@material-ui/icons';

export interface Props {
  position: { x: number; y: number };
  tooltip?: string;
  onClick?: () => void;
}

export const InteractiveMapPOI: React.FC<Props> = (props) => {
  return (
    <HtmlTooltip
      hidden={props.tooltip !== undefined}
      title={props.tooltip || ''}
    >
      <div
        className="interactivemap-poi"
        style={{ top: `${props.position.y}%`, left: `${props.position.x}%` }}
        onClick={props.onClick}
      >
        <StylesProvider injectFirst>
          <Place className="interactivemap-poi-icon" />
        </StylesProvider>
      </div>
    </HtmlTooltip>
  );
};

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#333',
    fontSize: '0.9em',
  },
}))(Tooltip);
